<template>
  <div>
    <el-card
      class="box-card"
      shadow="never"
    >
      <div
        slot="header"
        class="card-header"
      >
        <span>优惠群管理</span>
        <el-button
          type="primary"
          size="small"
          plain
          @click="couponVisible = true"
        >
          编辑优惠群
        </el-button>
      </div>
      <div>
        <div
          v-if="coupon"
          class="goods-box"
        >
          <ul class="goods-list">
            <li class="item">
              <div
                class="item-type"
                :class="coupon.card_type"
              >
                {{ coupon.card_type_val }}
              </div>
              <div class="item-info">
                <h4 class="title">
                  {{ coupon.title }}
                </h4>
              </div>
            </li>
          </ul>
        </div>
        <div
          v-else
          class="meter-text"
        >
          请选则优惠群
        </div>
      </div>
    </el-card>
    <!-- 选择优惠券 -->
    <CouponSelect
      :coupon-visible="couponVisible"
      choose-one
      @closeCouponDialog="closeCouponDialog"
      @chooseCoupon="chooseCoupon"
    />
  </div>
</template>

<script>
import CouponSelect from '@/components/couponSelect'
export default {
  components: {
    CouponSelect
  },
  model: {
    prop: 'coupon',
    event: 'couponChange'
  },
  props: {
    coupon: {
      type: Object
    }
  },
  data () {
    return {
      couponVisible: false
    }
  },
  methods: {
    closeCouponDialog () {
      this.couponVisible = false
    },
    // 选择图片
    chooseCoupon (selectdata) {
      console.log(selectdata, '选择的商品')
      let coupon = selectdata[0]
      this.couponVisible = false
      this.$emit('couponChange', coupon)
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-box {
  overflow: hidden;
  zoom: 1;
  .goods-list {
    overflow: hidden;
    zoom: 1;
    .item {
      border: 1px solid rgba(0, 0, 0, 0.05);
      padding: 4px;
      margin-bottom: 12px;
      margin-right: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      width: 40%;
      float: left;
      .num {
        position: absolute;
        left: 0;
        top: 0;
        width: 16px;
        height: 16px;
        background: rgba(0, 0, 0, 0.25);
        text-align: center;
        line-height: 16px;
        color: #fff;
        font-size: 12px;
      }
      &-type {
        width: 32px;
        height: 32px;
        color: #fff;
        font-size: 17px;
        text-align: center;
        line-height: 32px;
        &.cash {
          background: #ec808d;
        }
        &.discount {
          background: #81d3f8;
        }
        &.gift {
          background: #facd91;
        }
      }
      &-info {
        flex: 1;
        padding-left: 20px;
        .title {
          font-size: 14px;
          color: #262626;
          height: 22px;
          line-height: 22px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .sku {
          font-size: 12px;
          color: #262626;
          height: 22px;
          line-height: 22px;
        }
      }
    }
  }
}
.meter-text {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 12px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

::v-deep {
  .el-card__header {
    padding: 5px 20px;
  }
}
.box-card {
  margin-bottom: 20px;
}
</style>
